const API_BASE = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

async function request(path, options = {}) {
  const token = localStorage.getItem('token');
  const headers = { ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    throw new Error(err.detail || 'Error de servidor');
  }
  if (res.headers.get('content-type')?.includes('text/csv')) {
    return res.blob();
  }
  return res.json();
}

export const api = {
  // Auth
  login: (data) => request('/auth/login', { method: 'POST', body: JSON.stringify(data) }),
  register: (data) => request('/auth/register', { method: 'POST', body: JSON.stringify(data) }),
  testLogin: () => request('/auth/test-login', { method: 'POST' }),
  
  // Seed & Reset
  seed: () => request('/seed', { method: 'POST' }),
  reset: () => request('/reset', { method: 'POST' }),
  
  // Dashboard
  dashboard: () => request('/dashboard'),
  
  // Catalog
  catalog: (params = '') => request(`/catalog${params ? '?' + params : ''}`),
  getProduct: (id) => request(`/catalog/${id}`),
  createProduct: (data) => request('/catalog', { method: 'POST', body: JSON.stringify(data) }),
  updateProduct: (id, data) => request(`/catalog/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  brands: () => request('/brands'),
  uploadCatalog: (file) => {
    const form = new FormData();
    form.append('file', file);
    return request('/catalog/upload', { method: 'POST', body: form });
  },
  processCatalogUpload: (stagingId, mapping) => request(`/catalog/upload/${stagingId}/process`, { method: 'POST', body: JSON.stringify(mapping) }),
  
  // Upload
  upload: (file, fileType) => {
    const form = new FormData();
    form.append('file', file);
    form.append('file_type', fileType);
    return request('/upload', { method: 'POST', body: form });
  },
  processUpload: (id, mapping) => request(`/upload/${id}/process`, { method: 'POST', body: JSON.stringify(mapping) }),
  uploads: () => request('/uploads'),
  
  // Homologation
  homologation: (params = '') => request(`/homologation${params ? '?' + params : ''}`),
  approveHomologation: (id, data) => request(`/homologation/${id}/approve`, { method: 'POST', body: JSON.stringify(data) }),
  rejectHomologation: (id) => request(`/homologation/${id}/reject`, { method: 'POST' }),
  aiAssist: (data) => request('/homologation/ai-assist', { method: 'POST', body: JSON.stringify(data) }),
  
  // Inventory
  inventory: (params = '') => request(`/inventory${params ? '?' + params : ''}`),
  
  // Orders
  suggestedOrders: (params = '') => request(`/orders/suggested${params ? '?' + params : ''}`),
  adjustOrder: (data) => request('/orders/adjust', { method: 'POST', body: JSON.stringify(data) }),
  confirmOrder: (data) => request('/orders/confirm', { method: 'POST', body: JSON.stringify(data) }),
  exportOrders: (brand = '') => request(`/orders/export${brand ? '?brand=' + brand : ''}`),
  
  // Reports
  salesByBrand: () => request('/reports/sales-by-brand'),
  trends: () => request('/reports/trends'),
  productReport: (id) => request(`/reports/product/${id}`),
  
  // Audit
  audit: (params = '') => request(`/audit${params ? '?' + params : ''}`),
  
  // AI
  executiveSummary: () => request('/ai/executive-summary', { method: 'POST' }),
  
  // Users
  users: () => request('/users'),
};

export default api;
